export const TRANSACTION_TYPES = {
  EXPENSE: 1, 
  REVENUE: 2,
};

export const TRANSACTION_TYPE_LABELS = {
  [TRANSACTION_TYPES.EXPENSE]: "مصروف",
  [TRANSACTION_TYPES.REVENUE]: "إيراد",
};